import Cookies from 'js-cookie';
import { getBaseUrl } from '../utils/apiHelper';
import authService from './authService';

const API_URL = `${getBaseUrl()}/api/users`;

const userService = {
    getAllUsers: async () => {
        try {
            console.log("🔍 Fetching all users...");
            const userId = Cookies.get("userId"); // Retrieve User ID from cookies

            if (!userId) {
                console.error("❌ No User ID found in cookies.");
                throw new Error("User ID is missing. Ensure it is set in cookies.");
            }

            console.log(" User ID retrieved:", userId);

            console.log("📤 Sending request to fetch all users");

            const response = await authService.authenticatedFetch(`${API_URL}`, {
                method: "GET",
            });
            console.log("📥 Received response:", response.status, response.statusText);

            const data = await response.json();
            console.log("📄 Response data:", data);
            console.log("📄 data.users:", data.users);
            console.log("📄 Type of data.users:", typeof data.users);
            console.log("📄 Is data.users an array?", Array.isArray(data.users));
            
            if (!response.ok) {
                console.error("❌ Failed to fetch users:", data.message);
                throw new Error(data.message || "Failed to fetch users.");
            }

            if (!data.users) {
                console.error("❌ No users property in response:", data);
                throw new Error("Invalid response format from server - missing users array");
            }

            console.log("✅ Users fetched successfully:", data.users);
            return data.users;
        } catch (error) {
            console.error("❌ Error fetching users:", error.message);
            throw error;
        }
    },

    getUserWithClient: async (userId) => {
        try {
            console.log(`🔍 Fetching user with client info for user ID: ${userId}...`);

            const response = await authService.authenticatedFetch(`${API_URL}/${userId}`, {
                method: "GET",
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch user with client info.");
            }

            console.log("✅ User with client info fetched successfully:", data.user);
            return data.user;
        } catch (error) {
            console.error("❌ Error fetching user with client info:", error.message);
            throw error;
        }
    },

    updateUserClient: async (userId, clientId) => {
        try {
            console.log(`🔄 Updating client association for user ID: ${userId} to client ID: ${clientId}...`);

            const endpoint = `${API_URL}/${userId}/client`;
            console.log(`📡 Sending PUT request to endpoint: ${endpoint}`);

            const response = await authService.authenticatedFetch(endpoint, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ clientId }),
            });

            const contentType = response.headers.get("content-type");
            if (!response.ok) {
                console.error(`❌ Server responded with status ${response.status}: ${response.statusText}`);
                if (contentType && contentType.includes("application/json")) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Failed to update user's client association.");
                } else {
                    const errorText = await response.text();
                    console.error("❌ Server response:", errorText);
                    throw new Error(`Unexpected server response: ${errorText}`);
                }
            }

            const data = await response.json();
            console.log("✅ User's client association updated successfully:", data.user);
            return data.user;
        } catch (error) {
            console.error("❌ Error updating user's client association:", error.message);
            throw error;
        }
    },
};

export default userService;
